var _path, _g, _g2, _circle, _circle2, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRoadmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 1068,
    viewBox: "0 0 285 1068",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 61V259.761H110V447.479H187V644.092H110V819.235H187V1012.47",
    stroke: "white",
    strokeOpacity: 0.27,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 68,
    r: 28,
    fill: "#F0B90B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 1000,
    r: 28,
    fill: "#F0B90B"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 71.5,
    r: 15.5,
    fill: "#FF9D0A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 1003.5,
    r: 15.5,
    fill: "#FF9D0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.104 371.904C33.472 373.68 31.552 374.592 29.344 374.592C27.376 374.592 25.648 373.824 23.728 371.76C31.216 369.648 36.304 363.312 36.304 355.2C36.304 345.216 28.624 337.92 18.208 337.92C7.792 337.92 0.112 345.264 0.112 355.2C0.112 364.512 6.88 371.568 16.288 372.384C21.232 377.568 24.64 379.344 29.2 379.344C32.752 379.344 35.776 377.952 37.984 375.36L35.104 371.904ZM6.4 355.2C6.4 348.336 11.44 343.392 18.208 343.392C24.976 343.392 30.016 348.336 30.016 355.2C30.016 362.064 24.976 367.008 18.208 367.008C11.44 367.008 6.4 362.064 6.4 355.2ZM38.3215 338.4V343.632H45.4255V372H51.6655V338.4H38.3215Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.104 746.904C33.472 748.68 31.552 749.592 29.344 749.592C27.376 749.592 25.648 748.824 23.728 746.76C31.216 744.648 36.304 738.312 36.304 730.2C36.304 720.216 28.624 712.92 18.208 712.92C7.792 712.92 0.112 720.264 0.112 730.2C0.112 739.512 6.88 746.568 16.288 747.384C21.232 752.568 24.64 754.344 29.2 754.344C32.752 754.344 35.776 752.952 37.984 750.36L35.104 746.904ZM6.4 730.2C6.4 723.336 11.44 718.392 18.208 718.392C24.976 718.392 30.016 723.336 30.016 730.2C30.016 737.064 24.976 742.008 18.208 742.008C11.44 742.008 6.4 737.064 6.4 730.2ZM54.2598 727.272L62.4198 717.576V713.4H39.5238V718.632H54.7878L47.1558 727.704V731.976H50.2278C55.3158 731.976 57.5238 733.944 57.5238 736.968C57.5238 740.088 54.8838 742.056 50.4198 742.056C46.6278 742.056 42.9798 740.76 40.5798 738.744L37.8918 743.592C41.0117 746.04 45.7638 747.48 50.5157 747.48C59.5398 747.48 63.8118 742.584 63.8118 736.92C63.8118 731.88 60.5958 728.088 54.2598 727.272Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.104 566.904C253.472 568.68 251.552 569.592 249.344 569.592C247.376 569.592 245.648 568.824 243.728 566.76C251.216 564.648 256.304 558.312 256.304 550.2C256.304 540.216 248.624 532.92 238.208 532.92C227.792 532.92 220.112 540.264 220.112 550.2C220.112 559.512 226.88 566.568 236.288 567.384C241.232 572.568 244.64 574.344 249.2 574.344C252.752 574.344 255.776 572.952 257.984 570.36L255.104 566.904ZM226.4 550.2C226.4 543.336 231.44 538.392 238.208 538.392C244.976 538.392 250.016 543.336 250.016 550.2C250.016 557.064 244.976 562.008 238.208 562.008C231.44 562.008 226.4 557.064 226.4 550.2ZM268.546 561.72L277.522 553.176C282.177 548.808 283.09 545.832 283.09 542.568C283.09 536.616 278.386 532.92 271.09 532.92C265.57 532.92 260.914 534.984 258.322 538.488L262.69 541.848C264.562 539.448 267.298 538.344 270.562 538.344C274.69 538.344 276.802 540.12 276.802 543.192C276.802 545.064 276.226 547.032 272.962 550.152L259.618 562.824V567H284.385V561.72H268.546Z",
    fill: "url(#paint2_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 122,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1",
    x: 119,
    y: 932,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -0.491182,
    y1: 325,
    x2: 52.4215,
    y2: 325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF710A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: -0.261023,
    y1: 700,
    x2: 60.7231,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF710A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 219.739,
    y1: 520,
    x2: 280.723,
    y2: 520,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF710A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoadmap);
export default __webpack_public_path__ + "static/media/icon-roadmap.a37af6e544617292d3f6780dee0864a5.svg";
export { ForwardRef as ReactComponent };